import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import activitiesReducer from "./slices/activitiesSlice";
import routesReducer from "./slices/routesSlice";
import coursesReducer from "./slices/coursesSlice";
import statsReducer from "./slices/statsSlice";
import uploadReducer from "./slices/uploadSlice";
import languageReducer from "./slices/languageSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    activities: activitiesReducer,
    routes: routesReducer,
    courses: coursesReducer,
    stats: statsReducer,
    upload: uploadReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
